import React from 'react';
import { Stack, Text, CompactPeoplePicker, IconButton, IPersonaProps, IBasePickerSuggestionsProps } from '@fluentui/react';
import { getTextFromItem } from '../utils/helpers';
import { selectedItemListStyles, selectedItemStyles } from '../utils/styles';

interface TaskPickerProps {
    onTaskResolveSuggestions: (searchText: string) => Promise<IPersonaProps[]> | null;
    onTaskSelected: (persona: IPersonaProps) => IPersonaProps | null;
    onRemoveTask: () => void;
    selectedTaskPersona?: IPersonaProps;
    suggestionProps: IBasePickerSuggestionsProps;
    isDarkmode: boolean;
}

export const TaskPicker: React.FC<TaskPickerProps> = ({
    onTaskResolveSuggestions,
    onTaskSelected,
    onRemoveTask,
    selectedTaskPersona,
    suggestionProps,
    isDarkmode,
}) => {
    return (
        <Stack tokens={{ childrenGap: 10 }}>
            <Text variant="medium" styles={{ root: { fontWeight: 600 } }}>
                Select Task *
            </Text>
            <CompactPeoplePicker
                pickerCalloutProps={{ styles: { root: { '.ms-Persona-coin': { display: 'none' } } } }}
                styles={{ root: { width: '100%' } }}
                onResolveSuggestions={onTaskResolveSuggestions}
                itemLimit={10}
                getTextFromItem={getTextFromItem}
                pickerSuggestionsProps={suggestionProps}
                className={'ms-PeoplePicker'}
                inputProps={{
                    'aria-label': 'Task Picker',
                    placeholder: 'Search here to select a task...',
                }}
                resolveDelay={500}
                onItemSelected={onTaskSelected}
            />
            {selectedTaskPersona && (
                <Stack className={selectedItemListStyles}>
                    <Stack horizontal className={selectedItemStyles}>
                        <Stack>
                            <Text variant="mediumPlus" styles={{ root: { fontWeight: 600 } }}>
                                {selectedTaskPersona.text}
                            </Text>
                            <Text variant="small" styles={{ root: { color: isDarkmode ? '#C8C6C4' : '#605E5C' } }}>
                                {selectedTaskPersona.secondaryText}
                            </Text>
                        </Stack>

                        <IconButton iconProps={{ iconName: 'Cancel' }} title="Remove task" ariaLabel="Remove task" onClick={onRemoveTask} />
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
};
